// extracted by mini-css-extract-plugin
module.exports = {"AdminRelatif":"adminRelatif_AdminRelatif__nGKHE"};